import { render, staticRenderFns } from "./exchangeRateChangeTrend.vue?vue&type=template&id=8b66942a&scoped=true"
import script from "./exchangeRateChangeTrend.vue?vue&type=script&lang=js"
export * from "./exchangeRateChangeTrend.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateChangeTrend.vue?vue&type=style&index=0&id=8b66942a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b66942a",
  null
  
)

export default component.exports